export default "__VITE_ASSET__f203f432__"